<script setup lang="ts">
import type { ShareButtonsProps } from '@/types/appTypes'

const props = withDefaults(defineProps<ShareButtonsProps>(), { title: '' })

const app = useNuxtApp()
const route = useRoute()

const url = app.$makeFullPath(route)
const fixedTitle = encodeURIComponent(props.title)
const fixedContent = encodeURIComponent(`${props.title} ${url}`)

const twitterUrl = `https://twitter.com/intent/tweet?url=${url}&text=${fixedTitle}`
const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}&t=${fixedTitle}`
const lineUrl = `http://line.me/R/msg/text/?${fixedContent}`
</script>

<template>
  <ul class="c-shareButtons">
    <li class="c-shareButtons_item l-blank-icon-none">
      <a
        v-bind:href="facebookUrl"
        class="fb-share-button"
        target="_blank"
        title="facebook-share"
        data-layout="button_count"
      >
        <v-icon color="#3b5998">
          mdi-facebook
        </v-icon>
      </a>
    </li>
    <li class="c-shareButtons_item l-blank-icon-none">
      <a
        v-bind:href="lineUrl"
        class="line-share-button"
        target="_blank"
        title="line-send"
      >
        <img
          class="image"
          src="@/assets/images/logo-social-line.png"
        >
      </a>
    </li>
    <li class="c-shareButtons_item l-blank-icon-none">
      <a
        v-bind:href="twitterUrl"
        class="x-share-button"
        target="_blank"
        title="x-tweet"
        data-show-count="false"
        data-lang="ja"
      >
        <i class="c-shareButtons_item_x_icon" />
      </a>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-shareButtons {
  display: flex;
  margin-left: 20px;
  padding-left: 0;

  @include responsive.mq_down(sp) {
    margin-top: 15px;
    margin-left: 0;
  }

  &_item {
    width: 60px;
    height: 40px;

    &_x_icon {
      width: 22px;
      height: 22px;
      background: url("@/assets/images/icon-x.png") no-repeat;
    }

    > a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;

      &:hover {
        opacity: 0.7;
        text-decoration: none;
      }

      > img {
        display: block;
      }
    }
  }
}
</style>
